import {actionTypes} from '../const';
const initState = {
    ncnpstatus : '0',
    showPayMenu : true,
    showLogMenu : false,
    showOtherMenu : false,
    showAlertMenu : false,
    ncnpDays:0
}

const configuration = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.CONFIGURATION_SUCCESS:
            return Object.assign({}, state, {
                ncnpstatus:action.ncnpstatus,
                ncnpDays:action.ncnpDays               
            });
        case actionTypes.CHANGE_CONFIGURATION: 
            return Object.assign({}, state, {
                ncnpstatus:action.ncnpstatus ,
                ncnpDays:action.ncnpDays  
            });
        case actionTypes.UPDATE_TOGGLE_SIDEBARMENU: 
            return Object.assign({}, state, {
                showPayMenu : action.showPayMenu,
                showLogMenu : action.showLogMenu,
                showOtherMenu : action.showOtherMenu,
                showAlertMenu : action.showAlertMenu     
            });
        default:
            return state;
    }
}
export default configuration